// IIFE
(($) => {
  let menuItems = $(".menus .menu .menu__item a");

  menuItems.each((_, item) => {
    $(item).on("mouseover", (e) => {
      let href = $(item).data('href');
      closeAll();
      let submenu = $(`.submenus .submenu#${href}`);
      $(item).parent().addClass("menu__item--active");
      submenu.addClass("submenu--opened");
    })
    $('.menus .menu').on("mouseout", closeAll)
  });

  function closeAll() {
    let submenus = $(".submenus .submenu");
    submenus.removeClass("submenu--opened");
    menuItems.each((_, item2) => {
      $(item2).parent().removeClass("menu__item--active");
    });
  }
})(jQuery);
